import { Constants } from './Constants';

import { Dispatcher } from './Dispatcher';

export interface Action {
    actionType: Constants;
}

export function check<T extends Action>(action: Action, id: Constants): action is T {
    return action.actionType === id;
}

export module I {
    export interface CREATE_GROUP extends Action {
        def;
        name: string;
        members: any[];
        description?: string;
        //menuName?: string
    }

    export interface UPDATE_GROUP extends Action {
        def;
        id: number;
        name: string;
        members: any[];
        description?: string;
        //menuName?: string;
    }
}

export class Actions {
    public loadUsers(force?) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_USERS,

            force: force
        });
    }

    public loadUsersFinish(success) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_USERS_FINISH,

            success: success
        });
    }

    public createUser(
        def,
        displayName: string,
        login: string,
        email: string,
        password: string,
        groupsList: any[],
        sendEmail?: boolean
    ) {
        this.dispatcher.handleViewAction({
            actionType: Constants.CREATE_USER,

            def: def,
            displayName: displayName,
            Login: login,
            Email: email,
            Password: password,
            groupsList: groupsList,
            sendEmail: sendEmail
        });
    }

    public createUserFinish(success) {
        this.dispatcher.handleViewAction({
            actionType: Constants.CREATE_USER_FINISH,

            success: success
        });
    }

    public editUser(def, id, displayName: string, login: string, email: string, groupsList: any[], password?: string) {
        this.dispatcher.handleViewAction({
            actionType: Constants.EDIT_USER,

            def: def,
            id: id,
            displayName: displayName,
            Login: login,
            Email: email,
            groupsList: groupsList,
            Password: password
        });
    }

    public editUserFinish(id, success, user) {
        this.dispatcher.handleViewAction({
            actionType: Constants.EDIT_USER_FINISH,

            id: id,
            success: success,
            user: user
        });
    }

    public removeUser(id) {
        this.dispatcher.handleViewAction({
            actionType: Constants.REMOVE_USER,

            id: id
        });
    }

    public removeUserFinish(id, success) {
        this.dispatcher.handleViewAction({
            actionType: Constants.REMOVE_USER_FINISH,

            id: id,
            success: success
        });
    }

    public recoverPassword(userid, name) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RECOVER_PASSWORD,
            userid: userid,
            name: name
        });
    }

    public recoverPasswordFinish(success, userid, name) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RECOVER_PASSWORD_FINISH,
            success: success,
            userid: userid,
            name: name
        });
    }

    public loadGroups(force?) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_GROUPS,
            force: force
        });
    }

    public loadGroupsFinish(success) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_GROUPS_FINISH,
            success: success
        });
    }

    public createGroup(def, name: string, members: number[], description?: string) {
        this.dispatcher.handleViewAction<I.CREATE_GROUP>({
            actionType: Constants.CREATE_GROUP,
            def: def,
            name: name,
            members: members,
            description: description
        });
    }

    public createGroupFinish(success, name) {
        this.dispatcher.handleViewAction({
            actionType: Constants.CREATE_GROUP_FINISH,
            success: success,
            name: name
        });
    }

    public updateGroup(def: JQuery.Deferred<any>, id: number, name: string, members: any[], description?: string) {
        this.dispatcher.handleViewAction<I.UPDATE_GROUP>({
            actionType: Constants.UPDATE_GROUP,
            def: def,
            id: id,
            name: name,
            members: members,
            description: description
        });
    }

    public updateGroupFinish(id, success, name, obj?) {
        this.dispatcher.handleViewAction({
            actionType: Constants.UPDATE_GROUP_FINISH,
            id: id,
            success: success,
            name: name,
            obj: obj
        });
    }

    public deleteGroup(id, name) {
        this.dispatcher.handleViewAction({
            actionType: Constants.DELETE_GROUP,

            id: id,
            name: name
        });
    }

    public deleteGroupFinish(id, success, name) {
        this.dispatcher.handleViewAction({
            actionType: Constants.DELETE_GROUP_FINISH,

            id: id,
            success: success,
            name: name
        });
    }

    public loadGroupMembers(id) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_GROUP_MEMBERS,

            id: id
        });
    }

    public loadGroupMembersFinish(id) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_GROUP_MEMBERS_FINISH,

            id: id
        });
    }

    public loadUserMembers(id) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_USER_MEMBERS,

            id: id
        });
    }

    public loadUserMembersFinish(id) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_USER_MEMBERS_FINISH,

            id: id
        });
    }

    public importADUsers(users) {
        this.dispatcher.handleViewAction({
            actionType: Constants.IMPORT_AD_USERS,

            users: users
        });
    }

    public importADUsersFinish(count) {
        this.dispatcher.handleViewAction({
            actionType: Constants.IMPORT_AD_USERS_FINISH,

            count: count
        });
    }

    constructor(private dispatcher: Dispatcher) {}

    public static get(dispatcher: Dispatcher) {
        return new Actions(dispatcher);
    }
}
